import classNames from "../../../utils/classNames"

export const CheckboxInput = ({ label, register, registerName, disabled = false, cols = "sm:col-span-1", onChange = (value) => {}, watch = undefined, className = "", rounded = false }) => {

  const value = watch ? watch(registerName) : undefined;

  return (
    <div className={cols}>
      <label className="text-sm font-medium text-gray-500">
        {label}
      </label>
      <input
        {...register(registerName)}
        disabled={disabled}
        type="checkbox"
        className={classNames(disabled ? "bg-gray-300" : "", rounded ? "rounded-md" : "", "ml-1 border-1 border-gray-300", className)}
        onChange={(e) => {
          // if(e.target.checked == value) return;
          if(onChange) onChange(e.target.checked);
        }}
      />
    </div>
  )
}